import { render, staticRenderFns } from "./shikanManage.vue?vue&type=template&id=43bffe31&"
import script from "./shikanManage.vue?vue&type=script&lang=js&"
export * from "./shikanManage.vue?vue&type=script&lang=js&"
import style0 from "./shikanManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports